import type { Principle, RoadmapPhase } from '../types/project'

export const profile = {
  name: 'Pablo Sebastián Marchetti Orayen',
  handle: 'SolarisPKN',
  aliases: ['SolarisPKN', 'Pablo Kouta Nya', 'TecnOtakus'],
  role: 'Especialista en Infraestructura IT',
  location: 'Villars, Buenos Aires, Argentina',
  openSince: 'junio 2026',
  headline: 'Ingeniería transparente',
  intro:
    'Más de 10 años trabajando con Linux, redes, servidores, hardware y automatización. Construyo sistemas que resuelven problemas reales de mi propio homelab, de estudios de streaming y de negocios de mi zona. Desde junio de 2026 los publico documentados, abiertos y bajo GPL-3.0.',
  disciplines: [
    'Linux',
    'Infraestructura IT',
    'Redes y hosting',
    'Automatización',
    'Sistemas embebidos',
    'Desarrollo web',
    'Streaming',
  ],
  email: 'contacto@solarispkn.com.ar',
  github: 'https://github.com/SolarisPKN',
  labs: 'https://labs.solarispkn.com.ar',
  portfolio: 'https://labs.solarispkn.com.ar/es/portfolio',
  orcid: 'https://orcid.org/0009-0008-3003-1736',
}

export const manifesto = {
  before:
    'Durante años hice cosas que nunca publiqué. Escribía scripts, armaba servidores, documentaba soluciones, producía contenido — y lo guardaba. Tenía miedo de que alguien me lo robara y lo comercializara antes que yo.',
  turn: 'El conocimiento es poder. Pero si no se comparte, tarde o temprano se muere con vos.',
  after:
    'Eso no es lo que quiero. Prefiero que mis ideas circulen, que alguien las use, las mejore o las discuta, antes que verlas apagarse en un disco. Por eso en junio de 2026 abrí todo: repos públicos, documentación bilingüe y GPL-3.0 como licencia por defecto.',
}

export const licensing = {
  headline: 'GPL-3.0 por defecto',
  body: 'Todo lo que desarrollo se publica bajo GPL-3.0: podés usarlo, estudiarlo, modificarlo y redistribuirlo, siempre que lo derivado siga siendo igual de libre. Es la licencia que garantiza que lo abierto no se vuelva a cerrar.',
  exception:
    'La única excepción son los modpacks de Minecraft que armo en CurseForge, que van bajo MIT.',
  note:
    'Algunos repos todavía declaran MIT en su archivo de licencia: es una actualización pendiente, no un cambio de criterio.',
}

export const principles: Principle[] = [
  {
    title: 'El conocimiento cerrado se muere',
    body: 'Guardar lo que sabés no lo protege, lo condena. Publicarlo es la única forma de que sobreviva y le sirva a alguien más.',
  },
  {
    title: 'GPL-3.0, no por trámite',
    body: 'Copyleft a propósito: lo que se abre tiene que seguir abierto. Quien mejore mi trabajo comparte esa mejora con el resto.',
  },
  {
    title: 'Documentar es parte de construir',
    body: 'Un proyecto sin README es un proyecto que no existe. Cada repo explica qué resuelve, cómo funciona por dentro y qué falta — en inglés y en español.',
  },
  {
    title: 'Modular antes que monolítico',
    body: 'Conectores, módulos, firmware desacoplado. Agregar una plataforma nueva o una herramienta nueva nunca debería obligar a reescribir el núcleo.',
  },
  {
    title: 'La eficiencia se mide',
    body: 'Bajar el CPU de 240 a 80 MHz, apagar Bluetooth, dormir cuando no hay nada que hacer. Si una optimización no se puede medir, no se declara.',
  },
  {
    title: 'Honestidad sobre el estado',
    body: 'Los proyectos dicen si están en desarrollo, en concepto o probados sólo en mi hardware. Las estimaciones se presentan como estimaciones.',
  },
]

export const roadmap: RoadmapPhase[] = [
  {
    phase: 'Fase 1',
    title: 'Fundación',
    items: ['Sitio inicial', 'Estructura de proyectos', 'Despliegue público'],
    done: true,
  },
  {
    phase: 'Fase 2',
    title: 'Documentación',
    items: ['Sistema de documentación', 'Páginas por proyecto', 'Sección de arquitectura'],
    done: false,
  },
  {
    phase: 'Fase 3',
    title: 'Comunidad',
    items: ['Cuentas de usuario', 'Membresías', 'Organización de contenido'],
    done: false,
  },
  {
    phase: 'Fase 4',
    title: 'Distribución',
    items: ['Distribución de productos', 'Sistema de licencias', 'Integraciones avanzadas'],
    done: false,
  },
]
